import { AlertCircle } from 'lucide-react';

interface CompleteProfileModalProps {
  onComplete: () => void;
  onClose: () => void;
}

export default function CompleteProfileModal({ onComplete, onClose }: CompleteProfileModalProps) {
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl max-w-sm w-full shadow-2xl">
        <div className="p-8">
          <div className="flex items-center justify-center mb-5">
            <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center">
              <AlertCircle className="text-orange-500" size={32} strokeWidth={2.5} />
            </div>
          </div>

          <h2 className="text-xl font-bold text-gray-900 text-center mb-2">
            Complete Onboarding First
          </h2>

          <p className="text-gray-500 text-center text-sm mb-6 leading-relaxed">
            You need to complete your health assessment before you can edit your profile.
          </p>

          <div className="space-y-3">
            <button
              onClick={onClose}
              className="w-full bg-white hover:bg-gray-50 text-gray-700 py-3.5 rounded-xl font-semibold text-sm transition-colors border border-gray-200"
            >
              Go to Dashboard
            </button>

            <button
              onClick={onComplete}
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3.5 rounded-xl font-bold text-sm transition-colors"
            >
              Complete Onboarding
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
